import { render, staticRenderFns } from "./myPersonal.vue?vue&type=template&id=bb33ab6e&scoped=true&"
import script from "./myPersonal.vue?vue&type=script&lang=js&"
export * from "./myPersonal.vue?vue&type=script&lang=js&"
import style0 from "./myPersonal.vue?vue&type=style&index=0&id=bb33ab6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb33ab6e",
  null
  
)

export default component.exports